module.exports = __webpack_public_path__ + "img/MCD_Kontakt_Quart_Teaser_Furchert_01.a597ffbe.jpg";